export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Lt-9468907656d60546757b75df93db4fe3.woff";